import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import Link from "@mui/material/Link"
import { useNavigate } from "react-router-dom"
import store from "configureStore"
import { persistStore } from "redux-persist"
import { isMobile } from "react-device-detect"
import LayoutWithModal from "components/Layout/LayoutWithModal"
import { modalSelector } from "components/Modal/ModalSelector"
import LaunchIcon from "@mui/icons-material/Launch"
import RightArrowButton from "components/Button/RightArrowButton"
import { planActions } from "store/actions/PlanAction"
import { qrActions } from "store/actions/QRAction"
import { userInfoActions } from "store/actions/UserInfoAction"
import { couponCodeAction } from "store/actions/CouponCodeAction"
import { uuidActions } from "store/actions/UUIDAction"
import { v4 as uuidv4 } from "uuid"
import isHttpMaintenance from "utils/HttpMaintenanceCheck"
import getStatus from "apis/getStatus"
import shakensho from "images/shakensho.jpg"
import kazashite from "../../images/logo-kazashite.png"
import { APP_URL, Colors } from "../../Const"
import styles from "./styles.module.scss"
/**
 * Step0 トップ画面
 */
const Top = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState(false)

  const checkMaintenance = async () => {
    const res = await getStatus()
    if (isHttpMaintenance(res)) {
      // HTTP MAINTENANCE CHECK
      navigate(APP_URL.MAINTENANCE)
    }
  }
  useEffect(() => {
    // ストアの初期化
    dispatch(planActions.reset())
    dispatch(qrActions.reset())
    dispatch(userInfoActions.reset())

    // ローカルストレージの削除
    const persistor = persistStore(store)
    persistor.purge()

    const queryString = window.location.search

    if (queryString) {
      const paramString = queryString.substring(1)
      paramString.split("&").forEach((param) => {
        const temp = param.split("=")
        if (temp[0] === "code") {
          dispatch(couponCodeAction.updateCouponCode(temp[1]))
        }
      })
    }
    // UUIDの初期化
    dispatch(uuidActions.updateUUID(uuidv4()))
    checkMaintenance()
  }, [])

  // Local Components
  const TitleAndPrepareText = () => (
    <div className={styles.title_PrepareText}>
      <div className={styles.title_PrepareText__titleImage}>
        <img src={kazashite} alt="かざして自動車保険お見積り" />
      </div>
      <div className={styles.title_PrepareText__prepareText}>
        <div className={styles.title_PrepareText__borderTop} />
        <span>
          車検証の二次元バーコードを
          <br />
          カメラで読み取り
          <br />
          お車の情報を自動で入力
          <br />
          手軽に保険のお見積りができます
        </span>
        <div className={styles.title_PrepareText__borderBottom} />
      </div>
    </div>
  )
  const SelectCarType = () => (
    <div className={styles.selectCarType}>
      <div className={styles.selectCarType__body}>
        <div className={styles.title_PrepareText__imageContainer}>
          <div className={styles.title_PrepareText__image}>
            <div>
              <b>お手元に車検証をご用意ください</b>
            </div>
            <img src={shakensho} alt="車検証画像" />
          </div>
        </div>
        <div className={styles.selectCarType__buttonGroup}>
          <RightArrowButton
            color={Colors.Orange}
            arrowColor={Colors.White}
            text="車検証を読み取る"
            text2="（見積り開始）"
            onClick={() => {
              if (isMobile) {
                navigate(APP_URL.USAGE)
              } else {
                navigate(APP_URL.UPLOAD)
              }
            }}
            isSquareOnPC
          />
        </div>
        <a className={styles.selectCarType__directEntry} href="/car">
          <div className={styles.selectCarType__directEntry_text}>お車の情報を直接入力して見積る</div>
        </a>
      </div>
      <div className={styles.selectCarType__links}>
        <Link href="/target" underline="always" color="secondary" target="_blank" rel="noreferrer">
          お見積りできるお車について
        </Link>
        <LaunchIcon className={styles.externalLink} />
      </div>
      <div className={styles.selectCarType__links}>
        <Link
          href="https://www.sompo-direct.co.jp/otona/clause/"
          underline="always"
          color="secondary"
          target="_blank"
          rel="noreferrer"
        >
          お見積り可能な条件
        </Link>
        <LaunchIcon className={styles.externalLink} />
      </div>
    </div>
  )
  const ToOriginalSite = () => (
    <div className={styles.toOriginalSite}>
      <div className={styles.toOriginalSite__container}>
        <div className={styles.toOriginalSite__header}>
          <span>
            すでにおとなの自動車保険にご契約いただいている場合は、おとなの２台目割引が適用される可能性がありますので、マイページからご試算ください。
          </span>
        </div>
        <a
          href="https://www.sompo-direct.co.jp/mypage_contract/base/login/login?fnc=1"
          target="_blank"
          rel="noreferrer"
        >
          <div className={`${styles.toOriginalSite__card} ${isMobile ? "" : styles.hover}`}>
            <h3>おとなの自動車保険をご契約済みの方</h3>
            <span>ＳＯＭＰＯダイレクトのマイページへ</span>
            <LaunchIcon className={styles.mui_launch} />
          </div>
        </a>
        <div className={styles.toOriginalSite__explanation}>
          <span>保険の開始日は本日から30日後を設定しています。</span>
          <span>
            ご案内はあくまで概算です。詳細な見積りについては、
            <b className={styles.aboutHome}>
              <Link
                href="https://www.sompo-direct.co.jp/otona/?cid=WHP001"
                underline="always"
                color="primary"
                target="_blank"
                rel="noreferrer"
              >
                当社ホームページ
                <LaunchIcon className={styles.externalLinkHome} />
              </Link>
            </b>
            からご試算ください。
          </span>
          <span>
            車検証から取得する情報は、見積りに必要な4項目「用途車種」「型式」「車名」「初度登録年月（初度検査年月）」に限定しており、個人情報は取得していません。
          </span>
        </div>
      </div>
    </div>
  )
  return (
    <LayoutWithModal
      openModal={openModal}
      closeModal={() => {
        setOpenModal(false)
      }}
      innerContents={modalSelector("impossible")}
    >
      <div className={styles.root}>
        <TitleAndPrepareText />
        <SelectCarType />
        <ToOriginalSite />
      </div>
    </LayoutWithModal>
  )
}

export default Top
